import Swiper from "./vendor/swiper";

new Swiper(".carousel-slides", {
	spaceBetween: 30,
	speed: 500,
	autoplay: {
		delay: 5000,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

new Swiper(".recent-posts-slides", {
	spaceBetween: 30,
	speed: 500,
	autoplay: {
		delay: 5000,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});
